module.exports = __webpack_public_path__ + "img/intelligence1.c0b6a50f.png";